import { ReactElement } from 'react';

import { PrintTemplateUnmarkAsFavoriteCommand } from '@dreryk/egabinet-document-template-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarPositiveEvent,
   HeartIcon,
   IconFillColor,
   IconWrapper,
   Tooltip,
} from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../../translations';

const t =
   patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.modal.form.table.columns.actions
      .unmarkAsFavorite;

type ConsentsAndAuthorizationsDocumentsUnmarkAsFavoriteIconProps = {
   readonly documentId: number;
   readonly onUnmarkedAsFavorite: VoidFunction;
};

export const ConsentsAndAuthorizationsDocumentsUnmarkAsFavoriteIcon = (
   props: ConsentsAndAuthorizationsDocumentsUnmarkAsFavoriteIconProps
): ReactElement => {
   const { executeAsync: unmarkAsFavorite } = useCqrsCommand<void, unknown>(
      () => {
         const command = new PrintTemplateUnmarkAsFavoriteCommand();
         command.id = props.documentId;
         return command;
      },
      {
         onSuccess: () => {
            props.onUnmarkedAsFavorite();
            dispatchSnackbarPositiveEvent(t.successMessage);
         },
      }
   );

   return (
      <Tooltip testId={'unmarkAsFavorite'} content={t.tooltipMessage}>
         <IconWrapper onClick={unmarkAsFavorite} testId={'unmarkAsFavorite'} fillColor={IconFillColor.PRIMARY}>
            <HeartIcon />
         </IconWrapper>
      </Tooltip>
   );
};
